import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicDirective } from './dynamic-directive/dynamic.directive';
import {FormatNumberDirective} from './format-number/fomat-number.directive';

const directives = [DynamicDirective, FormatNumberDirective];

@NgModule({
  declarations: directives,
  imports: [CommonModule],
  exports: directives,
})
export class DirectivesModule {}
